import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./SentCv.css";
import Testimonial from "../../../Testimonial/Testimonial";

const SentCv = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    position: "",
    experience: "",
    message: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const sendToWhatsApp = (data) => {
    // Format the message for WhatsApp
    const message = `New CV Submission from MK eTech Website:%0A%0A
Name: ${data.name}%0A
Email: ${data.email}%0A
Phone: ${data.phone}%0A
Position: ${data.position}%0A
Experience: ${data.experience}%0A
Cover Letter: ${data.message || "Not provided"}%0A`;

    // Replace with your company's WhatsApp number (with country code, remove any spaces or special characters)
    const whatsappNumber = "919155599968";

    // Create the WhatsApp URL
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;

    // Open WhatsApp in a new tab
    window.open(whatsappUrl, "_blank");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Send data to WhatsApp
    sendToWhatsApp(formData);

    // In a real application, you would also handle file upload and form submission to a server here
    console.log(formData);
    setIsSubmitted(true);

    // Reset form after submission
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        name: "",
        email: "",
        phone: "",
        position: "",
        experience: "",
        message: "",
      });
    }, 5000);
  };

  return (
    <div>
      <Helmet>
        <title>Career Opportunities | Join Our Team of Tech Experts</title>
        <meta
          name="description"
          content="Explore career opportunities and see our technology stack. Submit your CV to join our team of experts working with cutting-edge technologies across various domains."
        />
        <meta
          name="keywords"
          content="career opportunities, tech jobs, IT careers, developer jobs, submit CV, tech careers, software engineering jobs, job application, join our team, technology stack, programming careers, web development jobs, mobile app development careers, blockchain jobs, AI careers, data science positions, cloud computing jobs, IT employment, tech recruitment, job vacancies, career growth, tech skills, professional development, work culture, employee benefits, job openings, hiring now, tech industry jobs, software developer careers, frontend developer jobs, backend developer positions, full-stack opportunities, DevOps careers, QA engineer jobs, technology experts, innovative workplace, tech stack expertise, career advancement, IT professionals, job seekers, resume submission"
        />
      </Helmet>
      <div className="mke-cv-portal">
        <div className="mke-main-container">
          <div className="mke-hero-section-send">
            <div className="mke-hero-content">
              <h2 className="mke-hero-title">Join Our Team of Innovators</h2>
              <p className="mke-hero-description">
                At MK eTech, we're always looking for talented individuals who
                are passionate about technology and innovation. Submit your CV
                and take the first step towards an exciting career with us.
              </p>
            </div>
            <div className="mke-hero-visual">
              <div className="mke-animated-circle"></div>
              <div className="mke-animated-square"></div>
            </div>
          </div>

          <div className="mke-form-container">
            {isSubmitted ? (
              <div className="mke-success-message">
                <div className="mke-checkmark">✓</div>
                <h3>Thank You for Your Application!</h3>
                <p>We have received your CV and will contact you shortly.</p>
                <p className="mke-whatsapp-notice">
                  <span className="mke-whatsapp-icon">📱</span>
                  Your details have been sent to our WhatsApp for quick
                  processing.
                </p>
              </div>
            ) : (
              <form className="mke-cv-form" onSubmit={handleSubmit}>
                <h2 className="mke-form-title">Submit Your CV</h2>

                <div className="mke-form-row">
                  <div className="mke-input-group">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="mke-form-input"
                    />
                    <label className="mke-input-label">Full Name</label>
                    <span className="mke-input-underline"></span>
                  </div>

                  <div className="mke-input-group">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="mke-form-input"
                    />
                    <label className="mke-input-label">Email Address</label>
                    <span className="mke-input-underline"></span>
                  </div>
                </div>

                <div className="mke-form-row">
                  <div className="mke-input-group">
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="mke-form-input"
                    />
                    <label className="mke-input-label">Phone Number</label>
                    <span className="mke-input-underline"></span>
                  </div>

                  <div className="mke-input-group">
                    <select
                      name="position"
                      value={formData.position}
                      onChange={handleChange}
                      required
                      className="mke-form-select"
                    >
                      <option value=""></option>
                      <option value="Frontend Developer">
                        Frontend Developer
                      </option>
                      <option value="Backend Developer">
                        Backend Developer
                      </option>
                      <option value="Full Stack Developer">
                        Full Stack Developer
                      </option>
                      <option value="UI/UX Designer">UI/UX Designer</option>
                      <option value="DevOps Engineer">DevOps Engineer</option>
                      <option value="Data Scientist">Data Scientist</option>
                    </select>
                    <label className="mke-input-label">
                      Position Applied For
                    </label>
                    <span className="mke-input-underline"></span>
                  </div>
                </div>

                <div className="mke-input-group">
                  <select
                    name="experience"
                    value={formData.experience}
                    onChange={handleChange}
                    required
                    className="mke-form-select"
                  >
                    <option value=""></option>
                    <option value="0-1 years">0-1 years</option>
                    <option value="1-3 years">1-3 years</option>
                    <option value="3-5 years">3-5 years</option>
                    <option value="5+ years">5+ years</option>
                  </select>
                  <label className="mke-input-label">Years of Experience</label>
                  <span className="mke-input-underline"></span>
                </div>

                <div className="mke-input-group">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="mke-form-textarea"
                  ></textarea>
                  <label className="mke-input-label">
                    Cover Letter (Optional)
                  </label>
                  <span className="mke-input-underline"></span>
                </div>

                {/* <div className="mke-file-upload-group">
                <label className="mke-file-label">Upload Your CV (PDF, DOC)</label>
                <div className="mke-file-input-container">
                  <input 
                    type="file" 
                    name="file" 
                    onChange={handleChange} 
                    accept=".pdf,.doc,.docx" 
                    required 
                  />
                  <span className="mke-file-custom"></span>
                </div>
              </div> */}

                <button type="submit" className="mke-submit-button">
                  Submit Application via WhatsApp
                </button>

                <p className="mke-whatsapp-info">
                  <span className="mke-whatsapp-icon-small">💬</span>
                  After submitting, you'll be redirected to WhatsApp to complete
                  the process and also send your Resume pdf file
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
      <Testimonial />

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SentCv;
